import Phaser from 'phaser';

const BG_OUTER = 0x450a0a;
const BG_INNER = 0x7f1d1d;
const ORBIT = 0xe5e7eb;
const ORBIT_GLOW = 0xf87171;
const NUCLEUS = 0xfbbf24;
const NUCLEUS_CORE = 0xfffbeb;
const ELECTRON = 0xf43f5e;
const STROKE = 0x0a0f1f;

export function drawAtom(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const orbitR = r * 0.72;
  const orbitNarrow = r * 0.24;

  g.lineStyle(Math.max(2, Math.floor(stroke * 0.9)), ORBIT, 1);
  drawEllipse(g, orbitR, orbitNarrow, 0);

  g.lineStyle(Math.max(2, Math.floor(stroke * 0.9)), ORBIT_GLOW, 0.9);
  drawEllipse(g, orbitR, orbitNarrow, Math.PI / 3);
  drawEllipse(g, orbitR, orbitNarrow, -Math.PI / 3);

  g.fillStyle(NUCLEUS, 1);
  g.fillCircle(0, 0, r * 0.22);
  g.fillStyle(NUCLEUS_CORE, 1);
  g.fillCircle(0, 0, r * 0.1);

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.6)), STROKE, 1);
  g.strokeCircle(0, 0, r * 0.22);

  g.fillStyle(ELECTRON, 1);
  const electronR = r * 0.09;
  const angles = [0, Math.PI / 3, -Math.PI / 3];
  for (const rot of angles) {
    const phase = rot + Math.PI * 0.4;
    const x = orbitR * Math.cos(phase) * Math.cos(rot) - orbitNarrow * Math.sin(phase) * Math.sin(rot);
    const y = orbitR * Math.cos(phase) * Math.sin(rot) + orbitNarrow * Math.sin(phase) * Math.cos(rot);
    g.fillCircle(x, y, electronR);
    g.lineStyle(1, STROKE, 1);
    g.strokeCircle(x, y, electronR);
  }
}

function drawEllipse(
  g: Phaser.GameObjects.Graphics,
  rx: number,
  ry: number,
  rotation: number,
) {
  const segments = 40;
  g.beginPath();
  for (let i = 0; i <= segments; i++) {
    const a = (i / segments) * Math.PI * 2;
    const ex = rx * Math.cos(a);
    const ey = ry * Math.sin(a);
    const x = ex * Math.cos(rotation) - ey * Math.sin(rotation);
    const y = ex * Math.sin(rotation) + ey * Math.cos(rotation);
    if (i === 0) g.moveTo(x, y);
    else g.lineTo(x, y);
  }
  g.strokePath();
}
